import { render, staticRenderFns } from "./Watch.vue?vue&type=template&id=ffaad7c6"
import script from "./Watch.vue?vue&type=script&lang=js"
export * from "./Watch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports